<app-breadcrumb
  [title]="page_name"
  [breadcrumb]="page_name"
  [currentUrl]="currentUrl"
></app-breadcrumb>
<!-- personal deatail section start -->
<section class="contact-page register-page">
  <div class="container">
    <div class="row">
      <div class="col-sm-3">
        <div class="account-sidebar" (click)="ToggleDashboard()">
          <a hre="javascript:void(0)" class="popup-btn">
            {{ "my account" | translate }}
          </a>
        </div>
        <div class="dashboard-left" [class.open]="openDashboard">
          <div class="collection-mobile-back" (click)="ToggleDashboard()">
            <span class="filter-back">
              <i class="fa fa-angle-left" aria-hidden="true"></i>
              {{ "Back" | translate }}
            </span>
          </div>
          <div class="block-content">
            <ul>
              <ul>
                <li>
                  <a data-lng="es" [routerLink]="'/pages/dashboard'">
                    {{ "address" | translate }}
                  </a>
                </li>
                <li>
                  <a data-lng="es" [routerLink]="'/pages/my-orders'">
                    {{ "orders" | translate }}
                  </a>
                </li>
                <li class="active">
                  <a data-lng="es" [routerLink]="'/pages/my-coupones'">
                    {{ "coupones" | translate }}
                  </a>
                </li>
                <li>
                  <a data-lng="es" [routerLink]="'/pages/browse-log'">
                    {{ "browse log" | translate }}
                  </a>
                </li>

                <li>
                  <a data-lng="es" [routerLink]="'/pages/profile'">
                    {{ "my profile" | translate }}
                  </a>
                </li>
                <li>
                  <a
                    data-lng="es"
                    href="javascript:void(0)"
                    (click)="userLogOut()"
                  >
                    {{ "logout" | translate }}
                  </a>
                </li>
              </ul>
            </ul>
          </div>
        </div>
      </div>
      <div class="col-sm-9 px-0">
        <div class="d-flex gap-3 mb-2 apply-input-btn">
          <input
            type="text"
            class="search-input form-control"
            [placeholder]="'coupon-code' | translate"
            [(ngModel)]="couponCode"
          />
          <button
            [disabled]="!couponCode.trim()"
            class="btn apply-btn"
            (click)="applyCoupon(couponCode.trim())"
          >
            {{ "apply" | translate }}
          </button>
        </div>
        <div class="upper-title-layout">
          <div
            class="title-up-block active-title-block"
            [ngClass]="
              usedCouponesActive
                ? 'not-active-title-block'
                : 'active-title-block'
            "
            (click)="usedCouponesActive = false"
          >
            <h3>{{'active-coupons'|translate}}</h3>
          </div>
          <div
            class="title-up-block"
            [ngClass]="
              usedCouponesActive
                ? 'active-title-block'
                : 'not-active-title-block'
            "
            (click)="usedCouponesActive = true"
          >
            <h3>{{'used-coupons'|translate}}</h3>
          </div>
        </div>
        <div class="content-layout-used-coupones" *ngIf="usedCouponesActive">
          <div class="loader-layout">
            <img
              class=""
              src="assets/images/loader.gif"
              *ngIf="!finished && usedCouponesList.length == 0"
            />
          </div>
          <app-ticket-coupon
            class="w-100"
            [activeCouponesList]="usedCouponesList"
          ></app-ticket-coupon>

          <div
            class="no-data-found"
            *ngIf="finished && usedCouponesList.length == 0"
          >
            {{ "no coupones found" | translate }}
          </div>
        </div>
        <div class="content-layout-used-coupones" *ngIf="!usedCouponesActive">
          <div class="loader-layout">
            <img
              class=""
              src="assets/images/loader.gif"
              *ngIf="!finished && activeCouponesList.length == 0"
            />
          </div>
          <app-ticket-coupon
            class="w-100"
            [activeCouponesList]="activeCouponesList"
          ></app-ticket-coupon>
          <div
            class="no-data-found"
            *ngIf="finished && activeCouponesList.length == 0"
          >
            {{ "no coupones found" | translate }}
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- login -->
<section #login class="full-sidebar" *ngIf="loginclicked">
  <div class="shadow login-sidebar">
    <i class="ti-close login-icon" (click)="close()"></i>
    <app-fast-login
      (step5Reached)="onStep5Reached()"
      (stepSuccessReached)="onstepSuccessReached()"
    ></app-fast-login>
  </div>
</section>
